import { __assign } from "tslib";
import { extractGroupBySettings } from '@keen.io/query';
import { setTransformationType } from './utils';
export var createParserSettings = function (_a) {
    var query = _a.query, steps = _a.steps, dateModifier = _a.dateModifier;
    var parserSettings = {
        mergePropertiesOrder: null,
        fillEmptyIntervalsKeys: false,
        dateModifier: null,
        transformation: setTransformationType(query, steps),
    };
    if (query) {
        var groupBy = query.group_by, interval = query.interval, orderBy = query.order_by, limit = query.limit;
        if (groupBy) {
            parserSettings = __assign(__assign({}, parserSettings), { mergePropertiesOrder: extractGroupBySettings(groupBy) });
        }
        if (interval && groupBy && orderBy && limit) {
            parserSettings = __assign(__assign({}, parserSettings), { fillEmptyIntervalsKeys: true });
        }
    }
    if (dateModifier) {
        parserSettings = __assign(__assign({}, parserSettings), { dateModifier: dateModifier });
    }
    return parserSettings;
};
